
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      viewerStyle: {
        transform: "none",
      },
      baseViewerDimensions: null as null | [number, number],
    };
  },
  computed: {
    availableHeatmaps() {
      return this.$store.state.activeHeatmaps;
    },
    isHeatmapsVisible() {
      return this.$store.state.isVisible;
    },
    opacity() {
      return this.$store.state.heatmapsOpacity;
    },
  },
  mounted() {
    document
      .getElementById("heatmaps")
      .addEventListener("heatmaps-pan-zoom", (event: CustomEvent) => {
        const viewer = event.detail.viewer;
        const center_pos = [
          (viewer.end_pos[0] + viewer.start_pos[0]) / 2,
          (viewer.end_pos[1] + viewer.start_pos[1]) / 2,
        ];
        const imageRatio = viewer.total_width / viewer.total_height;
        if (!this.baseViewerDimensions || event.detail.resetViewerSize) {
          this.baseViewerDimensions = <[number, number]>viewer.size;
        }
        const viewerRatio =
          this.baseViewerDimensions[0] / this.baseViewerDimensions[1];

        const zoom = viewer.zoom;
        if (imageRatio > viewerRatio) {
          const scale =
            (this.baseViewerDimensions[0] / viewer.total_width) * zoom;
          this.viewerStyle = {
            transform: `scale3d(${scale}, ${scale}, ${scale}) translate3d(${-(
              viewer.total_width * center_pos[0]
            )}px, ${-viewer.total_height * center_pos[1]}px,0)`,
          };
        } else {
          const scale =
            (this.baseViewerDimensions[1] / viewer.total_height) * zoom;
          this.viewerStyle = {
            transform: `scale3d(${scale}, ${scale}, ${scale}) translate3d(${-(
              viewer.total_width * center_pos[0]
            )}px, ${-viewer.total_height * center_pos[1]}px,0)`,
          };
        }
      });
  },
});
